// will add a custom media query here so that the styles are applied only when the height of the screen is between 300px and 450px.
// Since MUI's breakpoint system does not directly support height conditions
// Used this to support lanscape mode on mobile for discover mode
export const MEDIA_SCREEN_HEIGHT_250_920 = '@media (min-height: 250px) and (max-height: 920px)';
export const MEDIA_SCREEN_HEIGHT_ONE_TAP_SWIPE = '@media (min-height: 250px)';
